/**
 * Browsers grant autoplay-with-sound once per session, in response to a user gesture.
 * The player re-attaches `srcObject` whenever media is rebuilt (notably after an ICE
 * recovery), and that re-attach must not revoke a grant the session already earned.
 */
export function resolveAudioPlaybackGrant(previouslyGranted: boolean, soundElementMuted: boolean | null): boolean {
  if (previouslyGranted) {
    return true;
  }

  return soundElementMuted === false;
}
